module.exports = "/_next/static/images/2c07c34a6343b32c6bfa186ea8dfb5f1-sanpablo-4-desktop.jpg.webp";